import { FC, PropsWithChildren } from 'react';
import './DashboardTableSite.scss';

export const DashboardTableSite: FC<PropsWithChildren> = ({ children }) => {
  return <div className="DashboardTableSite">{children}</div>;
};
